export default __webpack_public_path__ + "cc7097c22e4eb4805bd69fc86e392fc7.woff";